/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AcrylicSurfaceComponent } from './acrylic-surface.component';
export { AcrylicSurfaceModule } from './acrylic-surface.module';